import { STORYBLOK_TYPES } from '~/lib/storyblok-types'
import NewInPage from '~/pages/new-in'

import getNewInPageStaticPropsFunction from '~/data/new-in-page-data'
import { getPaginatedStaticPathsFunction } from '~/data/page-data'

export default NewInPage

export const getStaticProps = getNewInPageStaticPropsFunction()
export const getStaticPaths = getPaginatedStaticPathsFunction({
  withPage: true,
  type: STORYBLOK_TYPES.NEW_IN,
  maxPathsInProduction: 10,
})
